import { SwiperOptions } from 'swiper/types';
import { Mousewheel, Navigation, Pagination } from 'swiper/modules';

export const SWIPER_CONFIG: SwiperOptions = {
  direction: 'vertical',
  slidesPerView: 1,
  roundLengths: true,
  grabCursor: false,
  simulateTouch: true,
  mousewheel: {
    forceToAxis: false,
    sensitivity: 1,  // Lower value for smoother scrolling
    releaseOnEdges: true, // Allows scrolling past the first and last slides
    thresholdTime: 1000,
    thresholdDelta: 7,
  },
  shortSwipes: true,
  // longSwipes: true,
  // longSwipesMs: 1000,
  // longSwipesRatio: 1,
  lazyPreloadPrevNext: 1,
  speed: 600,
  modules: [
    Mousewheel,
  ],
};
